import { message } from 'antd'
import './style'
import * as R from 'ramda'

message.config({ duration: 4 })

const queue = []

const customMessage = {
  info(message) {
    return sendMessageIfNotDuplicatedMessage(message, 'info')
  },
  success(message) {
    return sendMessageIfNotDuplicatedMessage(message, 'success')
  },
  error(message) {
    return sendMessageIfNotDuplicatedMessage(message, 'error')
  },
  warning(message) {
    return sendMessageIfNotDuplicatedMessage(message, 'warning')
  },
}

function sendMessageIfNotDuplicatedMessage(messageText, type) {
  if (isDuplicatedMessage(messageText, type)) {
    return
  }

  return sendMessage(messageText, type)
}

function isDuplicatedMessage(messageText, type) {
  const lastMessageInQueue = queue[queue.length - 1]

  return R.equals(lastMessageInQueue, { type, message: messageText })
}

function sendMessage(messageText, type) {
  queue.push({ type, message: messageText })
  return message[type](messageText).then(removeFirstElement)
}

function removeFirstElement() {
  queue.shift()
}

const toastr = customMessage
const toast = customMessage

export default customMessage
export { toastr, toast }



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/toast/index.js